import { jsx } from "react/jsx-runtime";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { validateTidalLicense } from "../../base/index.js";
function AlternateEmail(props) {
  return /* @__PURE__ */ jsx(
    AlternateEmailIcon,
    {
      "data-testid": "AlternateEmail",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AlternateEmail",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
AlternateEmail.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "AlternateEmail"
};
validateTidalLicense();
export {
  AlternateEmail
};
//# sourceMappingURL=AlternateEmail.js.map
